'use client';
import dynamic from 'next/dynamic';
import { Suspense } from 'react';

const ETCContainer = dynamic(() => import('@pc/components/molecules/sidebar/ETCContainer'), {
  ssr: false,
});
const SlickBanner = dynamic(() => import('@pc/components/molecules/sidebar/SlickBanner'), {
  ssr: false,
});

const ClientSideBar = () => {
  return (
    <>
      <Suspense fallback={null}>
        <ETCContainer />
      </Suspense>
      <Suspense fallback={null}>
        <SlickBanner />
      </Suspense>
    </>
  );
};

export default ClientSideBar;
